import AuthGate from "./AuthGate"

export default function TrainerRoute() {
  return <AuthGate allow={(user) => user.role !== "member"} />
}
